export class Load extends Phaser.Scene {
  create() {
    this.load.on('start', this._renderLoader, this);
  }

  _renderLoader() {
    if (this.content || !this.textures.exists('background_pattern')) return;
    this.scene.bringToTop(this.scene.key);
    this.add.image(910, 390, 'background_pattern');
    this.add.image(910, 350, 'title_loading');
    const bar = this.add.image(910, 420, 'loading', 'bar');
    const capLeft = this.add
      .image(bar.x - bar.width * 0.5 + 20, 418, 'loading', 'fill_cap_left')
      .setOrigin(1, 0.5);
    this.capright = this.add.image(910, 418, 'loading', 'fill_cap_right').setOrigin(0, 0.5);
    //282
    this.fill = this.add.image(capLeft.x, capLeft.y, 'loading', 'fill').setOrigin(0, 0.5);
    this.setProgress(0);
  }

  setProgress(value) {
    if (this.fill) {
      this.fill.displayWidth = 282 * value;
      this.capright.x = this.fill.x + this.fill.displayWidth;
    }
  }
}
